import { z } from "zod"

export const FORM_SCHEMA = z.object({
  location: z.string().min(1, "Please select a location"),
})
export type FORM_VALUES = z.infer<typeof FORM_SCHEMA>

// Remove the budget and duration options since they're no longer needed
// export const BUDGET_OPTIONS = [
//   { label: "Less than YYY", min: 0, max: 2500 },
//   { label: "XXX to YYY", min: 1000, max: 4000 },
//   { label: "XXX to YYY", min: 3000, max: 7000 },
//   { label: "More than XXX", min: 4000, max: 100000 },
// ]

// export const DURATION_OPTIONS = [
//   { label: "Less than 5 days", value: "1-5" },
//   { label: "5 to 10 days", value: "5-10" },
//   { label: "10 to 15 days", value: "10-15" },
//   { label: "15 or more days", value: "15-31" },
// ]
